/* eslint-disable @typescript-eslint/no-explicit-any */
import { put } from "redux-saga/effects";

import { OnboardingErrorType } from "../../../models/errors";
import { logError } from "../../../telemetry/error";
import { statusActions } from "../../actions/statusActions";

export function* storeError(e: any, type: OnboardingErrorType) {
  const errorResponse = (e as any)?.response;
  const errorData = errorResponse?.data;
  if (errorResponse) {
    logError(e, type);
    yield put(
      statusActions.updateError({
        code: errorData?.code ?? errorResponse.status ?? 500,
        message: errorData?.message ?? errorData?.statusText,
        stack: errorData?.stack,
        type,
      })
    );
  } else {
    yield put(statusActions.updateError(undefined));
  }
}
